import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IAuthState {
  isUserAuth: boolean;
  isAuthErrorModal: 'finally' | 'reauthenticate' | '';
}

const initialState: IAuthState = {
  isUserAuth: false,
  isAuthErrorModal: ''
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isUserAuth = action.payload;
    },
    setAuthErrorModal: (
      state,
      action: PayloadAction<'finally' | 'reauthenticate' | ''>
    ) => {
      state.isAuthErrorModal = action.payload;
    }
  }
});

export const { setIsAuth, setAuthErrorModal } = authSlice.actions;
export default authSlice;
